const Callbacks = {
    ON_ERROR: 'onError',
    ON_PROGRESS: 'onProgress',
}

// eslint-disable-next-line import/prefer-default-export
export { Callbacks }
